import React from 'react';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';

function formatDate(value) {
  if (!value) return '—';
  return dayjs(value).format('MMM DD, YYYY');
}

export default function TrainerMemberLogTable({
  logs = [],
  loading = false,
  mode = 'trainer',
  emptyMessage,
}) {
  if (loading) {
    return null;
  }

  const defaultEmpty =
    mode === 'member'
      ? 'No trainer assignment history for this member.'
      : 'No trainer assignment history for this trainer.';

  if (!logs || logs.length === 0) {
    return (
      <p className="text-gx-ink-soft mt-3">{emptyMessage || defaultEmpty}</p>
    );
  }

  const isMemberMode = mode === 'member';

  return (
    <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx animate-fadeIn overflow-auto mt-4">
      <Table size="small">
        <TableHead>
          <TableRow>
            {isMemberMode ? (
              <TableCell>Trainer</TableCell>
            ) : (
              <>
                <TableCell>Member ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Phone</TableCell>
              </>
            )}
            <TableCell>Assigned</TableCell>
            <TableCell>Ended</TableCell>
            <TableCell>Months</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((row) => (
            <TableRow hover key={row.logId}>
              {isMemberMode ? (
                <TableCell>{row.trainerName ?? '—'}</TableCell>
              ) : (
                <>
                  <TableCell>{row.memberCode ?? '—'}</TableCell>
                  <TableCell>{row.memberName ?? '—'}</TableCell>
                  <TableCell>{row.phone ?? '—'}</TableCell>
                </>
              )}
              <TableCell>{formatDate(row.assignedAt)}</TableCell>
              <TableCell>{row.isActive ? 'Active' : formatDate(row.endedAt)}</TableCell>
              <TableCell>{row.trainedMonths ?? '—'}</TableCell>
              <TableCell>
                <Chip
                  label={row.isActive ? 'Active' : 'Historical'}
                  color={row.isActive ? 'success' : 'default'}
                  size="small"
                  variant={row.isActive ? 'filled' : 'outlined'}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
